import { loadPostHog, whenIdle } from '@/lib/posthog-client'

// PostHog loads after the page does, off the critical path. Its initial $pageview and
// referrer/UTM properties are read at init, so they're still captured.
const start = () => whenIdle(() => void loadPostHog(), 3000)

if (document.readyState === 'complete') start()
else window.addEventListener('load', start, { once: true })
